@if (!isAppInitialized()) {
  <app-loader></app-loader>
} @else if (isStandaloneRoute()) {
  @if (isLoginRoute() && !authViewModel.isInitialized()) {
    <app-loader></app-loader>
  } @else {
    <router-outlet></router-outlet>
  }
} @else if (authViewModel.canAccess()) {
  <div class="app-layout">
    <app-sidebar class="app-sidebar"></app-sidebar>
    <div class="app-main">
      <app-header class="app-header"></app-header>
      <main class="app-content">
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
      </main>
    </div>

    <app-spinner></app-spinner>
  </div>
} @else {
  <!-- A rota protegida nunca fica visível quando a sessão foi invalidada. -->
  <app-loader></app-loader>
}
